import React, { useState } from "react";
import { Autosuggest } from "@amzn/awsui-components-react";
import JEPlaceholder from "src/models/je-allocation/JEPlaceholder";

export default function JEPlaceholderAutosuggest(props: {
    jePlaceholder: JEPlaceholder,
    lov: string[],
    inputJEPlaceholder?: string,
    onBlur: (ph: JEPlaceholder, value: string) => void, onChange?:(value:string) => void }
) {
    const { jePlaceholder, lov, inputJEPlaceholder, onBlur, onChange } = props;
    const [options, setOptions] = useState([] as any[]);
    const [value, setValue] = useState(jePlaceholder.value || '');

    const handleLoadItems = (event: any) => {
        let { filteringText } = event.detail;
        if (filteringText == null || filteringText == '') {
            filteringText = value;
        }

        if (filteringText == null || filteringText == '') {
            setOptions([]);
            return;
        }

        const filteredOptions = lov.filter((x: string) => x.toLowerCase().startsWith(filteringText.toLowerCase())).map((val: string) => { return {value: val} });
        setOptions(filteredOptions || []);
    }

    return <Autosuggest
        key={`jePlaceholderAutoSuggest${jePlaceholder.placeholderId}`}
        data-class="coaAutosuggest"
        onChange={({ detail }) => {
            setValue(detail.value);
            if (onChange) {
                onChange(detail.value);
            }
        }}
        onBlur={() => onBlur(jePlaceholder, value)}
        options={options}
        onLoadItems={(event) => handleLoadItems(event)}
        value={value}
        enteredTextLabel={val => `Use: "${val}"`}
        filteringType="manual"
        placeholder={inputJEPlaceholder || jePlaceholder.placeholderName}
        empty="No matches found"
        statusType={lov == null || lov.length == 0 ? 'loading' : 'finished'}
        loadingText="Loading"
    />
}
